<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable
        apiEndpoint="/api/admin/herb-productions"
        title="药材生产管理"
        :columns="columns"
        :formFields="formFields"
      />
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '../components/AdminTable.vue'

export default {
  name: 'HerbProductionsList',
  components: { Sidebar, AdminTable },
  data() {
    return {
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'herb_name', label: '药材名' },
        { key: 'province', label: '省份' },
        { key: 'city', label: '城市' },
        { key: 'created_at', label: '时间', type: 'date' }
      ],
      formFields: [
        { key: 'herb_name', label: '药材名', type: 'text', required: true },
        { key: 'province', label: '省份', type: 'text' },
        { key: 'city', label: '城市', type: 'text' }
      ]
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; padding: 30px; margin-left: 260px; }
</style>
